import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["title", "data-testid"]
const _hoisted_3 = {
  key: 0,
  class: "m-0 list-none p-0 text-xs text-neutral50"
}
const _hoisted_4 = ["data-testid"]
const _hoisted_5 = ["data-testid"]

import { computed } from 'vue'

import { QUEUE_TONE_PILL_CLASS } from '@/components/designSystem/QueueViews/types'
import {
  formatEligibilityReasons,
  resolveEligibilitySeal
} from '@/constants/payment-eligibility.constants'
import type { PaymentEligibilityView } from '@/types/payment-eligibility.types'

/**
 * Selo de elegibilidade de UM plantão (spec antecipe-registration §6, Q16/Q25):
 * "Elegível Antecipe / À vista / Só Fluxo" + motivos. `eligibility: null` é "não
 * calculado" — nunca "Só Fluxo".
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentEligibilitySeal',
  props: {
    eligibility: {},
    compact: { type: Boolean, default: false },
    showUncalculated: { type: Boolean, default: false },
    testId: { default: 'payment-eligibility' }
  },
  setup(__props: any) {

const props = __props;



const seal = computed(() => (props.eligibility ? resolveEligibilitySeal(props.eligibility) : null))

const reasonLines = computed(() =>
  props.eligibility ? formatEligibilityReasons(props.eligibility.reasons) : []
)

const compactTitle = computed(() =>
  seal.value
    ? [seal.value.label, ...reasonLines.value].join(reasonLines.value.length ? ' — ' : '')
    : undefined
)

return (_ctx: any,_cache: any) => {
  return (seal.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "flex flex-col gap-1",
        "data-testid": _ctx.testId
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["inline-flex w-fit items-center rounded-full px-2 py-0.5 text-xs font-bold", _unref(QUEUE_TONE_PILL_CLASS)[seal.value.tone]]),
          title: _ctx.compact ? compactTitle.value : undefined,
          "data-testid": `${_ctx.testId}-seal`
        }, _toDisplayString(_ctx.compact ? seal.value.shortLabel : seal.value.label), 11, _hoisted_2),
        (!_ctx.compact && reasonLines.value.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reasonLines.value, (line) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: line,
                  "data-testid": `${_ctx.testId}-reason`
                }, _toDisplayString(line), 9, _hoisted_4))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : (_ctx.showUncalculated)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "text-xs text-neutral50",
          "data-testid": `${_ctx.testId}-uncalculated`
        }, " Elegibilidade ainda não calculada ", 8, _hoisted_5))
      : _createCommentVNode("", true)
}
}

})